import { Button, notification, Popconfirm } from 'antd'
import { FC } from 'react'
import { useAppDispatch } from '../../../../../store/store'
import { useUpdateFormMutation } from '../../../../../store/api/forms-api'
import { formSetsApi } from '../../../../../store/api/form-sets-api'
import { FailureReason } from '../../../../../types/api/form'
import { FormsTableRow } from '../../types/forms-table-row'

interface RecordBreakageProps {
    row: FormsTableRow
    onSuccess: () => void
}

const RecordBreakage: FC<RecordBreakageProps> = ({ row, onSuccess }) => {
    const dispatch = useAppDispatch()
    const [updateForm, updateState] = useUpdateFormMutation()

    const onConfirm = async () => {
        if (!row.formDocumentId) return

        const result = await updateForm({
            docId: row.formDocumentId,
            body: {
                data: {
                    dateOfFailure: new Date().toISOString(),
                    failureReason: FailureReason.Breakage,
                    inStock: false,
                },
            },
        })

        if ('data' in result) {
            dispatch(formSetsApi.util.invalidateTags(['FormSet']))
            onSuccess()
            notification.success({ message: 'Поломка зафиксирована' })
        }
    }

    return (
        <Popconfirm
            onConfirm={onConfirm}
            title={'Зафиксировать поломку?'}
            description={'Форма будет отмечена как сломанная, отметка «В наличии» будет снята.'}
        >
            <Button loading={updateState.isLoading}>Зафиксировать поломку</Button>
        </Popconfirm>
    )
}

export default RecordBreakage
